module.exports = __webpack_public_path__ + "static/media/placeholder-loader.db1b2461.gif";